import React from "react";
import { Button, Result } from "antd";
import { Link } from "react-router-dom";

const App = ({ email }) => (
  <Result
    status="success"
    title="Successfully Updated!"
    subTitle={`Password Akun Anda (${email}) berhasil diubah`}
    extra={[
      <Link to="/login" key="login">
        <Button type="primary">Login</Button>
      </Link>,
    ]}
  />
);
export default App;
